import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderReport from "./HeaderReport";
import FilterDateReport from "./FilterDateReport";
import TabSeparationReport from "./TabSeparationReport";
import ChartReport from "./ChartReport";
import reportAction from "../../../store/actions/reportAction";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import CardReport from "./CardReport";
import TableReport from "./TableReport";

export default function ComponentReport() {
  return (
    <>
      <div id="report-top-header-container" className="w-100 bg-secondary">
        <HeaderReport />
        <FilterDateReport />
        <CardReport />
      </div>
      <div
        id="report-chart-and-table-container"
        className="border border-success w-100 rounded my-3"
      >
        <TabSeparationReport />
        <ChartReport />
        <TableReport />
      </div>
    </>
  );
}
